// A cancellation generation, not another source of account/session state.
// Sign-out invalidates pending sign-in, session reads and enrollment callbacks.
let epoch = 0;
export const accountAuthEpoch = () => epoch;
export const invalidateAccountAuthWork = () => { epoch += 1; };
